export const EMPLOYEES_COLUMNS = [
  { name: "employee", align: "left" },
  { name: "employee id", align: "left" },
  { name: "type", align: "left" },
  { name: "work mode", align: "center" },
  { name: "joined", align: "left" },
  { name: "status", align: "center" },
  { name: "actions", align: "center" },
];

export const EMPLOYMENT_STATUSES = [
  { value: "active", label: "Active", color: "success" },
  { value: "notice_period", label: "Notice period", color: "info" },
  { value: "exited", label: "Exited", color: "secondary" },
];

export const WORK_MODES = [
  { value: "on_site", label: "On-site", color: "secondary" },
  { value: "remote", label: "Remote", color: "info" },
];

export const EMPLOYEE_TYPES = [
  { value: "full_time", label: "Full time" },
  { value: "part_time", label: "Part time" },
  { value: "contract", label: "Contract" },
  { value: "intern", label: "Intern" },
];

export const EMPLOYEES_MESSAGES = {
  empty: "No employees found.",
  nameRequired: "Name is required.",
  tzRequired: "Select a timezone.",
  probationBeforeJoining: "Probation end date can't be before the joining date.",
  exitBeforeJoining: "Exit date can't be before the joining date.",
  updated: "Employee updated successfully.",
  archived: "Employee archived successfully.",
  datesWarning: "Changing the joining or probation end date changes this person's leave accrual.",
  tzWarning: "Changing the timezone changes where each day starts for their check-ins.",
};

export const labelFor = (options, value) =>
  options.find((option) => option.value === value)?.label || value || "—";
